module.exports = __webpack_public_path__ + "img/1.c358df4e.png";